import { render, staticRenderFns } from "./VideoMask.vue?vue&type=template&id=b445a4f8&scoped=true&"
import script from "./VideoMask.vue?vue&type=script&lang=js&"
export * from "./VideoMask.vue?vue&type=script&lang=js&"
import style0 from "./VideoMask.vue?vue&type=style&index=0&id=b445a4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b445a4f8",
  null
  
)

export default component.exports